import {
  OnInit,
  Component,
  ViewChild,
  signal,
  computed,
  AfterViewInit,
} from '@angular/core';

import { Utils } from 'src/app/utils/utils';
import { AppComponent } from 'src/app/app.component';
import { DateUtils } from 'src/app/utils/date-utils';
import { environment } from 'src/environments/environment';
import { HeaderComponent } from '../header/header.component';
import { MainComponent } from 'src/app/components/main/main.component';
import { JqWidgets } from 'src/app/utils/jqWidgets';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';
import { jqxWindowComponent } from 'jqwidgets-ng/jqxwindow';
import { PersonasService } from 'src/app/services/personas/personas.service';
import { PersonaModel } from 'src/app/services/personas/models/persona.model';
import { jqxInputComponent } from 'jqwidgets-ng/jqxinput';
import { jqxDropDownListComponent } from 'jqwidgets-ng/jqxdropdownlist';
import { BDT_RECURSOS, BdtService } from 'src/app/services/bdt/bdt.service';
import { BdtRecursoModel } from 'src/app/services/bdt/models/bdt-recurso.model';
import { PersonaCategoriaModel } from 'src/app/services/personas/models/persona-categoria.model';
import { NzModalService } from 'ng-zorro-antd/modal';
import { ExportService } from 'src/app/services/export/export.service';
import { WindowComponent } from 'movisat-common-gui';

@Component({
  selector: 'app-personas',
  templateUrl: './personas.component.html',
  styleUrls: ['./personas.component.css']
})
export class PersonasComponent implements OnInit, AfterViewInit {
  @ViewChild('listPersonas') public listPersonas: WindowComponent;
  @ViewChild('header') public header: HeaderComponent;
  @ViewChild('gridPersonas') public gridPersonas: jqxGridComponent;
  @ViewChild('formEdit') public formEdit: jqxWindowComponent;
  @ViewChild('ebNombre') public ebNombre: jqxInputComponent;
  @ViewChild('cbCategorias') public cbCategorias: jqxDropDownListComponent;

  protected actions = [{type: "button", action:"cancel", value: "", label: this.translate('Salir')}];

  public static _this: PersonasComponent;
  public environment = environment;
  private componentRef = null;
  public langGrid = JqWidgets.getLocalization('es');
  protected sourceGridPersonas;
  protected sourceGridPersonasAdapter;
  private personas: PersonaModel[] = [];
  public columnsGridPersonas: unknown = [];
  private personaEdit: PersonaModel;
  public editando = false;
  private categorias: BdtRecursoModel[] = [];

  protected loading = signal(false);

  protected countPartialResults = signal<number>(0);
  protected titleWindowSignal = computed(() => `${this.translate('Listado_personas')} (${this.countPartialResults()})`);

  protected translate(text: string): string {
    return AppComponent.translate(text);
  }

  public constructor(
    private personasService: PersonasService,
    private bdtService: BdtService,
    private modal: NzModalService,
    private exportService: ExportService
  ) {
    PersonasComponent._this = this;
  }

  public init(componentRef: unknown): void {
    this.componentRef = componentRef;
  }

  public ngOnInit(): void {
    this.getPersonas();
  }

  public ngAfterViewInit(): void {
    this.loading.set(true);
  }

  protected gridDataUpdate(): void {
    this.countPartialResults.set(this.gridPersonas.getrows().length);
  }

  public actionButtonClicked(event): void {
    if(event.action === 'cancel') {
      this.onClose();
      return;
    }
  }

  public initGridPersonas(): void {
    this.sourceGridPersonas = {
      datatype: 'json',
      datafields: [
        { name: 'id', type: 'number', map: 'id' },
        { name: 'identificador', type: 'string', map: 'identificador' },
        { name: 'nombre', type: 'string', map: 'nombre' },
        { name: 'apellidos', type: 'string', map: 'apellidos' },
        { name: 'email', type: 'string', map: 'email' },
        { name: 'telefono', type: 'string', map: 'telefono' },
        { name: 'nif', type: 'string', map: 'nif' },
        { name: 'categoria', type: 'string', map: 'categoria>nombre' },
        { name: 'selec', type: 'string', map: 'selec' },
      ],
      localdata: this.personas
    };
    this.sourceGridPersonasAdapter = new jqx.dataAdapter(this.sourceGridPersonas);

    this.columnsGridPersonas = [
      { datafield: 'id', hidden: true },
      { datafield: 'selec', hidden: true },
      {
        text: '',
        width: 60,
        columntype: 'text',
        sortable: false,
        editable: false,
        groupable: false,
        menu: false,
        clickable: false,
        filterable: false,
        resizable: false,
        rendered: (columnHeaderElement): void => {
          const buttonContainer1 = document.createElement('div');
          buttonContainer1.style.width = '100%';
          buttonContainer1.style.display = 'flex';
          buttonContainer1.style.justifyContent = 'center';

          buttonContainer1.id = `buttonContainerColumn_jqxButton`;
          columnHeaderElement[0].appendChild(buttonContainer1);
          const btnCrear = document.createElement('div');
          btnCrear.innerHTML =
            `<button class="button" style="height: 20px; width: 100%; padding: 0; margin: 0; cursor: pointer !important ; title="` +
            AppComponent.translate('Crear') + `"> <i style="font-size: 18px;" class="fa-solid fa-plus"></i></button>`;
          btnCrear.id = `buttonCrear_jqxButton`;
          buttonContainer1.appendChild(btnCrear);
          btnCrear.style.width = '50%';
          btnCrear.addEventListener('click', () => {
            this.personaEdit = new PersonaModel();
            this.onEdit();
          });
          return columnHeaderElement[0];
        },
        createwidget: (
          row: unknown,
          column: unknown,
          value: string,
          htmlElement: HTMLElement
        ): void => {
          this.initBtnColumn(row, column, value, htmlElement);
        },
        initwidget: (
          row: unknown,
          column: unknown,
          value: string,
          htmlElement: HTMLElement
        ): void => {
          this.initBtnColumn(row, column, value, htmlElement);
        },
      },
      {
        text: AppComponent.translate('Identificador'), columntype: 'textbox', datafield: 'identificador', width: 100,
        aggregates: [{
          'Total': function (aggregatedValue): void {
            return aggregatedValue + 1;
          }
        }],
        aggregatesrenderer: function (aggregates): string {
          let renderstring = '';
          if (aggregates["Total"] !== undefined) {
            renderstring = '<div style="text-align: left; margin-left: 4px;">' + AppComponent.translate('Total') + ': ' +
              aggregates["Total"] + ' </div>';
          }
          return renderstring;
        }
      },
      { text: AppComponent.translate('Nombre'), columntype: 'textbox', datafield: 'nombre', width: 150 },
      { text: AppComponent.translate('Apellidos'), columntype: 'textbox', datafield: 'apellidos', width: 300 },
      { text: AppComponent.translate('Correo_electronico'), columntype: 'textbox', datafield: 'email', width: 200 },
      { text: AppComponent.translate('Telefono'), columntype: 'textbox', datafield: 'telefono', width: 150 },
      { text: AppComponent.translate('Dni'), columntype: 'textbox', datafield: 'nif', width: 100 },
      { text: AppComponent.translate('Categoria'), columntype: 'textbox', datafield: 'categoria', width: 250 },
    ]
  }

  public updatefilterconditions = (type: string, defaultconditions: unknown): string[] => {
    return Utils.updatefilterconditions(type, defaultconditions);
  };

  public async initBtnColumn(
    //eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    row: any,
    column: unknown,
    value: unknown,
    htmlElement: HTMLElement
  ): Promise<void> {
    htmlElement.innerHTML = '';

    let rowdata;
    if (isNaN(row as number)) {
      rowdata = row.bounddata;
    } else {
      rowdata = this.gridPersonas?.getrowdata(row as number);
    }

    const btnContainer = document.createElement('div');
    btnContainer.style.display = 'flex';
    btnContainer.style.justifyContent = 'start';
    btnContainer.style.gap = '2px';
    btnContainer.style.padding = '2px';

    const btnEditar = document.createElement('div');
    btnEditar.innerHTML = `
      <button class="button" style="height: 23px; width: 25px; padding: 0; margin: 0; cursor: pointer !important;
      "title="${AppComponent.translate('Editar')}"><i class="fa-solid fa-pen-to-square"></i></button>
    `;
    btnEditar.id = 'buttonEdite_jqxButton';
    btnContainer.appendChild(btnEditar);
    btnEditar.addEventListener('click', async () => {
      this.personaEdit = this.personas.find(persona => persona.id == rowdata.id);
      if (this.personaEdit) {
        this.onEdit();
      }
    });

    const btnDelete = document.createElement('div');
    btnDelete.innerHTML = `
      <button class="button" style="height: 23px; width: 25px; padding: 0; margin: 0; cursor: pointer !important;
      "title="${AppComponent.translate('Borrar')}"><i class="fa-solid fa-trash"></i></button>
    `;
    btnDelete.id = 'buttonDelete_jqxButton';
    btnContainer.appendChild(btnDelete);
    btnDelete.addEventListener('click', async () => {
      this.personaEdit = this.personas.find(persona => persona.id == rowdata.id);
      if (this.personaEdit) {
        this.onDelete();
      }
    });

    htmlElement.appendChild(btnContainer);
  }

  public async getPersonas(): Promise<void> {
    this.personas = await this.personasService.getPersonas()
    this.initGridPersonas();
    this.loading.set(false);
  }

  public async eventFilter(): Promise<void> {
    this.header.searchInput['nativeElement'].value = '';
    this.getPersonas();
  }

  public async eventResetFilter(): Promise<void> {
    this.header.searchInput['nativeElement'].value = '';
    this.onBuscar();
  }

  public onEdit(): void {
    this.editando = true;
  }

  public onDelete(): void {
    if (this.personaEdit) {
      this.modal.confirm({
        nzTitle: '<i>' + AppComponent.translate('ATENCION') + '</i>',
        nzContent: AppComponent.translate('Quiere_borrar_persona') + ': ' + this.personaEdit.nombre + ' ?',
        nzCentered: true,
        nzCancelText: AppComponent.translate('CANCELAR'),
        nzOkText: AppComponent.translate('SI'),
        nzZIndex: 999,
        nzOnOk: async () => {
          if (await this.personasService.delPersona(this.personaEdit.id)) {
            for (let i = 0; i < this.personas.length; i++) {
              if (this.personas[i].id === this.personaEdit.id) {
                this.personas.splice(i, 1);
                break;
              }
            }
            MainComponent.getInstance().showSuccess('ATENCION', 'Registro_borrado', 2000);
            this.personaEdit = null;
            this.gridPersonas.updatebounddata();
          } else {
            MainComponent.getInstance().showError('ATENCION', 'No_se_ha_podido_borrar_el_registro', 2000);
          }
        }
      });
    } else {
      MainComponent.getInstance().showWarning('ATENCION', 'Seleccione_registro', 2000);
    }
  }

  public onDoubleClick(rowIndex: number): void {
    this.personaEdit = this.personas[rowIndex];
    this.onEdit();
  }

  public onCloseEdit(): void {
    this.editando = false;
  }

  public onOpenEdit(): void {
    const t = setTimeout(async () => {
      clearTimeout(t);
      this.formEdit.setTitle(`${AppComponent.translate('Personas')}`);
      this.ebNombre.focus();

      let index = 0;
      this.categorias = await this.bdtService.getRecursos(BDT_RECURSOS.Empleados);
      this.categorias = this.categorias.sort((a: BdtRecursoModel, b: BdtRecursoModel) => {
        if (a.Nombre > b.Nombre)
          return 1;
        if (a.Nombre < b.Nombre)
          return -1;
        return 0;
      });

      this.categorias.forEach((cat, i) => {
        this.cbCategorias.addItem({ label: cat.Nombre, value: cat.Id });
        if (cat.Id === this.personaEdit.idCategoria) {
          index = i;
        }
      });
      this.cbCategorias.selectedIndex(index);
    }, 500);
  }

  public async onGuardar(): Promise<void> {
    if (this.checkInfo()) {
      const res = await this.personasService.savePersona(this.personaEdit);
      if (res) {
        let register = this.personas.find(p => p.id == res.id);
        if (register) {
          register = res;
        } else {
          res.categoria = new PersonaCategoriaModel();
          const cat = this.categorias.find(cat => cat.Id == res.idCategoria);
          res.categoria.nombre = cat ? cat.Nombre : '';
          this.personas.push(res);
        }
        this.personaEdit = null;

        MainComponent.getInstance().showInfo('ATENCION', 'Registro_almacenado', 2000);
        this.formEdit.close();
        this.gridPersonas.updatebounddata();
      } else {
        MainComponent.getInstance().showError('ATENCION', 'Fallo_almacenar_info', 2000);
      }
    }
  }

  private checkInfo(): boolean {
    if (!this.personaEdit.nombre || this.personaEdit.nombre.length < 1) {
      MainComponent.showError('ATENCION', 'Introduzca_nombre', 2000);
      return false;
    }
    if (!this.dniValido(this.personaEdit.nif)) {
      MainComponent.showError('ATENCION', 'Dni_no_valido', 2000);
      return false;
    }
    if (!this.emailValido(this.personaEdit.email)) {
      MainComponent.showError('ATENCION', 'Email_no_valido', 2000);
      return false;
    }
    if (!this.telefonoValido(this.personaEdit.telefono)) {
      MainComponent.showError('ATENCION', 'Telefono_no_valido', 2000);
      return false;
    }
    return true;
  }

  private calcularLetraDni(dni: string): string {
    try {
      const letra = "TRWAGMYFPDXBNJZSQVHLCKET";
      const num = parseInt(dni);
      const pos = num % (letra.length - 1);
      return letra[pos];
    } catch {
      return '';
    }
  }

  public dniValido(dni: string): boolean {
    if (dni && dni.length > 0) {
      const regex = /^\d{1,8}[A-Za-z]$/;
      return regex.test(dni) && this.calcularLetraDni(dni).equalsTo(dni[dni.length - 1]);
    }
    return true;
  }

  private emailValido(email: string): boolean {
    if (email && email.length > 0) {
      const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      return regex.test(email);
    }
    return true;
  }

  private telefonoValido(telefono: string): boolean {
    if (telefono && telefono.length > 0) {
      const regex = /^[0-9]{6,9}$/;
      return regex.test(telefono);
    }
    return true;
  }

  public onBuscar(): void {
    let filterValue = '';

    if (this.header.searchInput['nativeElement'].value.length >= 3) {
      filterValue = this.header.searchInput['nativeElement'].value.toUpperCase();
    } else {
      filterValue = '';
    }

    this.personas.forEach(persona => {
      if (
        persona?.identificador?.compareWith(filterValue) ||
        persona?.nombre?.compareWith(filterValue) ||
        persona?.apellidos?.compareWith(filterValue) ||
        persona?.email?.compareWith(filterValue) ||
        persona?.telefono?.compareWith(filterValue) ||
        persona?.nif?.compareWith(filterValue) ||
        persona?.categoria?.nombre?.compareWith(filterValue)
      ) {
        persona['selec'] = 'selec';
      } else {
        persona['selec'] = '';
      }
    });

    // Compruebo si ya he creado el filtro "selec" anteriormente
    const filters = this.gridPersonas.getfilterinformation();
    if (filters.find(s => s.datafield === 'selec') === undefined) {
      const filtergroup = new jqx.filter();
      filtergroup.operator = 'and';
      filtergroup.addfilter(0, filtergroup.createfilter('stringfilter', 'selec', 'equal'));
      this.gridPersonas.addfilter('selec', filtergroup);
    }
    this.gridPersonas.applyfilters();
    this.gridPersonas.updatebounddata('data');
  }

  public onClose(): void {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
    PersonasComponent._this = null;
  }

  public onBindingComplete(): void {
    this.gridPersonas.sortby('nombre', 'asc');
    this.gridDataUpdate();
  }

  public onExportar(): void {
    this.exportService.exportFile(
      this.gridPersonas,
      DateUtils.formatDateAMDhms(new Date()) + '_' + this.translate('Personas') + '.xlsx'
    );
  }
}
